import { SimpleModal } from '@sequencehq/core-components'
import { FC } from 'react'

export const RemoveContactDialog: FC<{
  title: string
  isOpen: boolean
  onClose: () => void
  onConfirm: () => Promise<void>
}> = ({ title, isOpen, onClose, onConfirm }) => {
  return (
    <SimpleModal
      data-testid="contacts.archiveContactDialog"
      variant="dialog"
      disableSubmitOnEnter
      isDestructive
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      cancelButtonText="Cancel"
      submitButtonText="Continue"
      onSubmit={async () => {
        await onConfirm()
        return true
      }}
    >
      This will remove the contact from the customer's account. This action
      cannot be undone.
    </SimpleModal>
  )
}
